export default __webpack_public_path__ + "static/media/Gallery-17.6880e31c.jpeg";